import TableModule from "components/Modules/Collections/TableModule"
import { getDataFromFirestoreCollection } from "helpers/Firestore"
import React from "react"

const WebsiteNewsTable = () => {
  return (
    <TableModule
      getData={async () => {
        return await getDataFromFirestoreCollection({
          path: `Web/Corporate/DataBase/News/DataBase`,
          sortBy: { key: "publishDate", inverse: true },
        })
      }}
      columns={[{ key: "title", label: "Title" }]}
      searchKey={"title"}
    />
  )
}

export default WebsiteNewsTable
